import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  enableDataInsight = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.enableDataInsight = localStorage.getItem('enableDataInsight') === '1';
    console.log('Data Insight Enabled');
  }

  navigateToKMS() {
    localStorage.setItem('appContext', 'kms');
    this.router.navigate(['/get-answer']);
  }

  navigateToDataInsight() {
    localStorage.setItem('appContext', 'data-insight');
    this.router.navigate(['/data-insight']);
  }
}
